<h2 mat-dialog-title class="title-small">Edit Pricing Profile</h2>

<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Code</mat-label>
            <input matInput formControlName="code" readonly>
        </mat-form-field>

        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" maxlength="60">
            <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
        </mat-form-field>

        <mat-form-field class="custom-text-field" appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput rows="3" formControlName="description" maxlength="180"></textarea>
            <mat-error *ngIf="form.get('description')?.hasError('required')">Description is required</mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button type="button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="onSave()">Save</button>
</mat-dialog-actions>
